import { Check, Dot } from "lucide-react";
import { istDateTime } from "@/lib/format";

export function Timeline({ steps }) {
  return (
    <div className="space-y-0" data-testid="txn-timeline">
      {steps.map((s, i) => {
        const done = !!s.at;
        const last = i === steps.length - 1;
        const refund = s.key === "refunded";
        return (
          <div key={s.key} className="flex gap-3">
            <div className="flex flex-col items-center">
              <div
                className="flex h-6 w-6 items-center justify-center rounded-full border"
                style={{
                  borderColor: done ? (refund ? "#F59E0B" : "#10B981") : "#262626",
                  color: done ? (refund ? "#F59E0B" : "#10B981") : "#6B7280",
                  backgroundColor: done ? (refund ? "#F59E0B1a" : "#10B9811a") : "transparent",
                }}
              >
                {done ? <Check className="h-3.5 w-3.5" /> : <Dot className="h-4 w-4" />}
              </div>
              {!last && <div className="w-px flex-1 min-h-6" style={{ backgroundColor: "#262626" }} />}
            </div>
            <div className="pb-5">
              <div className="text-sm font-medium font-head">{s.label}</div>
              <div className="text-xs text-muted-foreground mono">{s.at ? istDateTime(s.at) : "Pending"}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
